import { ImageListItem } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { imageListClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const Title = styled("span")(() => ({
  color: colors.gray600,

  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

export const CollapsablePanelTitle = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  gap: "8px",

  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

export const CounterBadge = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",

  background: colors.gray600,
  color: colors.white,
  borderRadius: "16px",
  textAlign: "center",
  fontFamily: "Manrope",
  fontSize: "11px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  minHeight: "16px",
  minWidth: "16px",
}));

export const EmptyStateWrapper = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
}));

export const EmptyStateImageWrapper = styled("div")(() => ({
  height: "160px",
  width: "200px",
}));

export const ImageComponent = styled("img")(() => ({
  height: "100%",
  width: "100%",
}));

export const EmptyStateInfoWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const EmptyStateTitleInfo = styled("span")(() => ({
  color: colors.gray600,
  textAlign: "center",

  fontFamily: "Manrope",
  fontSize: "24px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "32px",
}));

export const EmptyStateSubTitleInfo = styled("span")(() => ({
  color: colors.gray600,
  textAlign: "center",

  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const AddNewSealWrapper = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",

  borderRadius: "20px",
  cursor: "pointer",
  height: "40px",
  marginTop: "30px !important",
  width: "40px",

  "&:hover": {
    background: `rgba(0, 0, 0, 0.04)`,
  },
}));

export const FieldHeader = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
}));

export const FieldLabel = styled("span")(() => ({
  color: colors.brandBlue600,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
}));

export const RemoveFieldWrapper = styled("div")(() => ({
  cursor: "pointer",
}));

export const FileInput = styled("input")(() => ({
  display: "none",
}));

export const SealPicturesList = styled(ImageListItem)(() => ({
  [`& .${imageListClasses.root}`]: {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    width: "255px",
  },
}));

const styles = makeStyles(() => ({
  modalStyles: {
    width: "862px !important",
  },
  panel: {
    "& header": {
      background: colors.gray50,
      padding: "16px 24px",
    },
    background: colors.gray50,
  },
  panelContent: {
    padding: "24px",
  },
  button: {
    width: "149px",
  },
  input: {
    width: "100% !important",
  },
  label: {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
  },
  image: {
    width: "255px",
    height: "115px",
    borderRadius: "8px",
    cursor: "pointer",
  },
  skeleton: {
    height: "220px !important",
    width: "100% !important",
    borderRadius: "8px",
  },
}));

export default styles;
